<template>
    <div>
        <mobile-tabs :active-name="activeName" :tab-list="tabList" @change="changeActive">
            <div class="container">
                <no-mobile-data v-if="show" />
                <div class="box">
                    <div
                        v-for="(item, index) in downloadList"
                        :key="'list' + index"
                        class="list"
                        @click="openDtl(item.name, item.description)"
                    >
                        <div class="list-top">
                            <p class="list-top__title">{{ item.name }}</p>
                            <img src="@/assets/mobile-imgs/download.png" class="list-top__img" />
                        </div>
                        <div class="list__desc">{{ item.description }}</div>
                    </div>
                </div>
            </div>
        </mobile-tabs>
        <the-dialog-dtl ref="dtlDialog"></the-dialog-dtl>
    </div>
</template>

<script>
import { resourcelist, resourcedtl } from '../service';
import NoMobileData from '@/components/mobile/base/no-mobile-data';
import MobileTabs from '@/components/mobile/tabs/mobile-tabs';
import TheDialogDtl from '../components/the-dialog-dtl.vue';
export default {
    components: {
        NoMobileData,
        MobileTabs,
        TheDialogDtl
    },
    data() {
        return {
            activeName: 'APP',
            tabList: [
                { name: 'OS', type: 'OS' },
                { name: '应用', type: 'APP' },
                { name: '工具', type: 'TOOL' }
            ],
            downloadList: [],
            params: {
                category: '',
                name: ''
            },
            loading: false,
            finished: false,
            refreshing: false,
            show: false
        };
    },
    async created() {
        this.onRefresh();
    },
    methods: {
        openDtl(name, dtl) {
            this.$refs.dtlDialog.open(name, dtl);
        },
        onRefresh() {
            this.changeActive(this.activeName);
        },
        changeActive(name) {
            this.activeName = name;
            this.downloadList = [];
            this.onLoad();
        },
        onLoad() {
            this.params.category = this.activeName;
            this.params.name = '';
            this.getList(this.params);
        },
        async getList(params) {
            const data = await resourcelist(params).catch(() => {
                this.show = true;
            });
            this.downloadList = this.downloadList.concat(data);
            this.refreshing = false;
            this.finished = true;
            if (this.downloadList.length === 0) {
                this.show = true;
            } else {
                this.show = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    min-height: calc(100vh - 110px);
    background: #f9fbfe;
}
.box {
    padding: 20px;
    box-sizing: border-box;
    .list {
        background: #fff;
        margin-bottom: 20px;
        position: relative;
        &-top {
            display: flex;
            align-items: center;
            height: 40px;
            padding: 0 16px;
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
            background: linear-gradient(295deg, #5ac1fb 0%, #0067ff 100%);
            border-radius: 4px 4px 0px 0px;
            &__title {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            &__img {
                width: 170px;
                height: 40px;
                position: absolute;
                top: 0;
                right: 0;
            }
        }
        &__desc {
            padding: 12px 16px;
            max-height: 80px;
            font-size: 13px;
            color: rgba(0, 0, 0, 0.6);
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        }
    }
}
</style>
